import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const MemorialUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Memorial University of Newfoundland"
      universityShortName="Memorial"
      slug="memorial-university"
      seoTitle="Memorial University Study Rooms | St. John's Campus Study Guide"
      seoDescription="Complete guide to study rooms at Memorial University. Find QEII Library, group rooms, and specialized study spaces. Plus free 24/7 online alternative."
      seoKeywords="memorial university study rooms, mun library, qeii library, st johns university study spaces, memorial newfoundland library"
      canonicalUrl="/study-room/memorial-university/"
      heroDescription="A comprehensive guide to study rooms at Memorial in St. John's, including QEII Library and specialized academic spaces."
      libraryWebsiteUrl="https://library.mun.ca/"
      libraryWebsiteName="Memorial Libraries"
      studySpaces={[
        {
          name: "QEII Library - Group Study Rooms (Floors 2-5)",
          features: "Bookable one day in advance for up to two hours.",
          feedback: "Limited to two-hour window and one-day-ahead booking makes planning tricky."
        },
        {
          name: "QEII Library - Single Study Rooms",
          features: "Individual rooms bookable one day ahead for up to two hours.",
          feedback: "Good for focused individual work; same booking limitations."
        },
        {
          name: "Videoconference Room",
          features: "Specialized room for video calls and virtual meetings.",
          feedback: "Useful for online presentations and interviews."
        },
        {
          name: "Assistive Technology Room",
          features: "Available for students registered with accessibility services.",
          feedback: "Valuable resource for students needing accommodations."
        },
        {
          name: "Honours Dissertation Rooms",
          features: "Bookable for up to two terms for thesis writing.",
          feedback: "Great for long-term focused dissertation work."
        },
        {
          name: "Graduate Study Rooms",
          features: "Daily or long-term bookable spaces for graduate students.",
          feedback: "Exclusive graduate access appreciated."
        },
        {
          name: "Centre for Newfoundland Studies Reading Room (3rd Floor)",
          features: "Quiet reading room with historical collections; no food or drink allowed.",
          feedback: "Peaceful atmosphere for serious research."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Book early in the morning to secure a group room. For a peaceful atmosphere, head to the <strong>Centre for Newfoundland Studies reading room</strong> but remember to leave snacks outside.
          </p>
          <p className="mb-4">
            Graduate students writing theses can apply for <strong>long-term dissertation rooms</strong>—bookable for up to two terms.
          </p>
          <p>
            Students appreciate the variety of specialized rooms but comment that group rooms are limited to a two-hour window and can only be booked one day ahead.
          </p>
        </>
      }
      summaryTips={[
        "Book first thing in the morning: Only one-day-ahead booking available.",
        "Apply for dissertation rooms: Available for up to two terms for thesis work.",
        "Visit Centre for Newfoundland Studies: Peaceful reading room (no food/drink).",
        "Check specialized rooms: Videoconference and assistive technology options available.",
        "Use CSW for advance planning: No one-day-ahead booking limitations."
      ]}
    />
  );
};

export default MemorialUniversity;
